import { enumsTypes } from "@shared/constants";

export type QueryParameterResult = {
  afterpay?: string;
  affirm?: string;
  basket?: string; // basket id
  error?: string;
  error_msg?: string;
  event_id__in?: string;
  eventRef?: string;
  id?: string;
  interac?: string;
  invoice_id?: string;
  isEmbedded?: string;
  link?: string;
  purchase_source_platform?: enumsTypes.PurchaseSourcePlatformMapIdType;
  q?: string;
  referral?: string;
  square?: string;
  tags?: string;
  token?: string;
};

export function getQueryParameters(
  str = document.location.search
): QueryParameterResult {
  const finalResult = str
    .replace(/(^\?)/, "")
    .split("&")
    .map(
      // eslint-disable-next-line
      function (n) {
        const buildResult =
          ((n = n.split("=")), // eslint-disable-line
          (n[1] = decodeURIComponent(n[1])), // eslint-disable-line
          (this[n[0]] = n[1]), // eslint-disable-line
          this);
        return buildResult;
      }.bind({})
    )[0];

  return finalResult;
}

/**
 * Compares an array of url patterns against the current url/host
 * Example input: ["local", "127.0.0.1", ":8000"]
 */
export function containsHostUrl(urlPatterns: string[]): boolean {
  const host = window.location.href;
  return Boolean(urlPatterns.find((string) => host.includes(string)));
}

export function normalizeUrl(url: string) {
  // Removes trailing slash if it exists
  const normalizedURL = url.endsWith("/") ? url.slice(0, -1) : url;
  return normalizedURL;
}

/* Dealing with query params that can be undefined, string or string[], gets messy,
 * so let's return an array for all cases
 */
export const normalizeQueryParam = (param?: string | string[]) => {
  if (typeof param === "string") {
    return param.split(",");
  }

  return param ?? [];
};

export function encodeData(
  baseUrl: string,
  data: Record<string, unknown>
): string {
  const urlParams = new URLSearchParams();

  Object.keys(data).forEach((key) => {
    const value = data[key];
    if (value !== undefined) {
      urlParams.append(key, String(value));
    }
  });

  const queryString = urlParams.toString();
  return queryString ? `${baseUrl}?${queryString}` : baseUrl;
}

/**
 * Guarantees a URL-like string by passing a primary input into a URL constructor,
 * and uses the fallback if it fails.
 */
export function ensuredUrl(primary: string, fallback: string) {
  try {
    const _ = new URL(primary);
    return primary;
  } catch {
    return fallback;
  }
}

/**
 * Ensures a URL uses HTTPS protocol by creating a new URL object
 * and forcing the protocol to be 'https:'.
 */
export function securedUrl(input: string | URL): URL {
  const url = typeof input === "string" ? new URL(input) : new URL(input.href);
  url.protocol = "https:";
  return url;
}
